import { SubAPI } from "./SubAPI";
export class MiscPricing extends SubAPI {
    list(props) { return this.fetcher.get("/api/quote-misc-prices", props); }
    upsert(props) { return this.fetcher.post("/api/quote-misc-price", props); }
    reOrder(props) { return this.fetcher.post("/api/quote-misc-price/reorder", props); }
    createPoForItem(props) { return this.fetcher.post("/api/misc-price/create-po-for-item", props); }
}
